import { render, staticRenderFns } from "./CookingTab.vue?vue&type=template&id=2c7aed14&scoped=true"
import script from "./CookingTab.vue?vue&type=script&lang=js"
export * from "./CookingTab.vue?vue&type=script&lang=js"
import style0 from "./CookingTab.vue?vue&type=style&index=0&id=2c7aed14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7aed14",
  null
  
)

export default component.exports